import { override } from "flarum/common/extend";
import icon from 'flarum/common/helpers/icon';

export default function (BaseField) {
  // console.log(BaseField, require("@fof-masquerade"));
  if (!!BaseField) {
    override(BaseField.prototype, "answerField", function () {
      const iconName = this.readAttribute(this.field, "icon");

      if (!this.answerContent()) return;

      return m(".Masquerade-Bio-Set", [
        m("span.Masquerade-Bio-Field", [
          iconName ? [icon(iconName), " "] : null,
          this.readAttribute(this.field, "name") + ": ",
        ]),
        m("span.Masquerade-Bio-Answer", this.answerContent()),
      ]);
    });
  }
}
